import type { BonusCampaign } from '../../../api/fetchers/bonusPromotions/types/bonus';
import { BonusStatus } from '../../../api/fetchers/bonusPromotions/types/constants';

import type { BonusPromoState } from './types';

export const updateBonusCampaignState = (state: BonusPromoState, payload: BonusCampaign): void => {
  if (state.eligibleBonusCampaign?.bonus.id !== payload.bonus.id) {
    state.forceBonusRefresh = true;
    return;
  }
  switch (payload.bonus.status) {
    case BonusStatus.Active:
      state.eligibleBonusCampaign = payload;
      state.activeBonusCampaign = { ...payload };
      break;
    case BonusStatus.Pending:
      state.eligibleBonusCampaign = payload;
      break;
    default:
      state.forceBonusRefresh = true;
      break;
  }
};
